import { useListSurvey } from '@frx/frx-react-context';
import { convertToArray, ListSurveysOptions, Survey } from '@frx/frx-services';

export const useContactSurveyId = ({
  categoryId,
}: {
  categoryId: ListSurveysOptions['list_category_id'];
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const { data: survey } = useListSurvey(
    { published_only: true, list_category_id: categoryId },
    {
      enabled: !!categoryId,
    }
  );

  console.log({ survey });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return convertToArray(survey?.surveys)?.find((sur: Survey) =>
    sur.surveyName.toLowerCase().includes('contact')
  )?.surveyId;
};
